import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { NonNullableFormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { NzFormDirective, NzFormItemComponent, NzFormControlComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzRowDirective, NzColDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NZ_MODAL_DATA, NzModalFooterDirective, NzModalTitleDirective } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-modal-from-to',
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzModalFooterDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzMessageModule,
        NzFormModule
    ],
    templateUrl: './modal-from-to.component.html',
    styleUrl: './modal-from-to.component.scss'
})
export class ModalFromToComponent implements OnInit {
    @Output() emitService = new EventEmitter();

    data = inject(NZ_MODAL_DATA);
    validateForm: FormGroup<{
        from: FormControl<number>;
        to: FormControl<number>;
    }>;

    readonly message = inject(NzMessageService);
    readonly fb = inject(NonNullableFormBuilder);
    private readonly modalRef = inject(NzModalRef);

    constructor(){
        this.validateForm = this.fb.group({
            from: [1, [Validators.required, Validators.min(1), Validators.max(this.data.max)]],
            to: [1, [Validators.required, Validators.min(1), Validators.max(this.data.max)]]
        });
    }

    async ngOnInit() {
        this.validateForm.controls.from.valueChanges.subscribe(x => {
            this.validateForm.controls.to.clearValidators();
            this.validateForm.controls.to.addValidators([Validators.required, Validators.min(x + 1), Validators.max(this.data.max)]);
            this.validateForm.controls.to.updateValueAndValidity();
            this.validateForm.controls.to.markAllAsTouched();
        });
    }

    async submitForm(): Promise<void> {
        try {

            if (!this.validateForm.valid) {
                this.message.error(`Porfavor, rellene correctamente los campos obligatorios`);
                return;
            }

            const response: { from: number, to: number } = { from: this.validateForm.controls.from.value, to: this.validateForm.controls.to.value };
            this.emitService.emit(response);
            this.modalRef.close();
        } catch (e: unknown) {
            if (e instanceof Error) {
                this.message.error(e.message);
            }
        }
    }

    handleCancel() {
        this.modalRef.close();
    }
}
